import { Component } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { ToolListService } from '@/shared/services/tool-list.service';

@Component({
  selector: 'app-ftic-course-dwf-apr-help-page',
  templateUrl: './ftic-course-dwf-apr-help-page.component.html',
  styleUrl: './ftic-course-dwf-apr-help-page.component.css',
  standalone: false,
})
export class FticCourseDwfAprHelpPageComponent {
  public env = environment;
  // Array to track hover states for each link
  isHovered: boolean[] = [false, false];

  constructor(public toolListService: ToolListService) {}

  ngOnInit(): void {}
  // Method to update hover state
  setHover(index: number, value: boolean) {
    this.isHovered[index] = value;
  }

  scroll(el: HTMLElement): void {
    el.scrollIntoView({ behavior: 'smooth' });
  }
}
